module.exports = __webpack_public_path__ + "media/images/ww10-6ea9e8ddd7a61b5ac6c0fd64711847fc.svg";